module.exports = "/remote-dist/2e1272778186dd0b5250be7c757624a4.png";